// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateLoadParameter from "@insite/client-framework/Store/Pages/MyLists/Handlers/UpdateLoadParameter";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import MyListsSearchFieldProductNumber from "@insite/content-library/Widgets/MyLists/MyListsSearchFieldProductNumber";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        getWishListsParameter: state.pages.myLists.getWishListsParameter,
    };
};

const mapDispatchToProps = {
    updateLoadParameter,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface MyListsFilterByProductStyles {
    wrapper?: InjectableCss;
}

export const filterByProductStyles: MyListsFilterByProductStyles = {
    wrapper: {
        css: css`
            && > div {
                padding: 0;
                width: 100%;
                position: relative;
            }
        `,
    },
};

const styles = filterByProductStyles;

const MyListsFilterByProduct = ({ getWishListsParameter, updateLoadParameter }: Props) => {
    return (
        <StyledWrapper data-test-selector="myListPage_productsFilter" {...styles.wrapper}>
            <MyListsSearchFieldProductNumber
                getWishListsParameter={getWishListsParameter}
                updateLoadParameter={updateLoadParameter}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyListsFilterByProduct),
    definition: {
        group: "My Lists",
        displayName: "Filter By Product",
        allowedContexts: ["MyListsPage"],
    },
};

export default widgetModule;
